const features = [
  {
    icon: 'ri-user-star-line',
    title: 'Servizio Personalizzato',
    desc: 'Ogni cliente è unico. Offriamo soluzioni su misura per ogni esigenza, con un approccio flessibile e attento.',
    color: 'text-red-500',
    border: 'border-red-900/30',
    bg: 'bg-red-950/10',
  },
  {
    icon: 'ri-global-line',
    title: 'Esperienza Internazionale',
    desc: 'Operiamo in tutta Europa, garantendo qualità e puntualità in ogni progetto, dalle competizioni alle fiere.',
    color: 'text-orange-500',
    border: 'border-orange-900/30',
    bg: 'bg-orange-950/10',
  },
  {
    icon: 'ri-shield-check-line',
    title: 'Affidabilità e Qualità',
    desc: 'Ogni attrezzatura è rigorosamente testata e pronta all\'uso, per garantire il massimo delle prestazioni.',
    color: 'text-amber-500',
    border: 'border-amber-900/30',
    bg: 'bg-amber-950/10',
  },
];

const AboutSection = () => (
  <section id="chi-siamo" className="relative bg-[#0a0a10] py-24 overflow-hidden">
    {/* Background */}
    <div
      className="absolute inset-0 opacity-20"
      style={{
        backgroundImage: `radial-gradient(ellipse at 80% 50%, rgba(220,38,38,0.12) 0%, transparent 60%)`,
      }}
    />

    <div className="relative z-10 max-w-7xl mx-auto px-6">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
        {/* Left - Image */}
        <div className="relative">
          <div className="relative rounded-2xl overflow-hidden h-[500px] md:h-[600px]">
            <img
              src="https://public.readdy.ai/ai/img_res/918fcfda5f89009acfd1eed901172303.jpg"
              alt="ELLE NOLO EQUIPMENT team"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#0a0a10]/80 via-transparent to-transparent" />
            <div className="absolute inset-0 border-2 border-red-600/20 rounded-2xl" />
          </div>

          {/* Floating badge */}
          <div className="absolute -bottom-6 -right-4 md:right-8 bg-[#0f0f18] border border-red-800/40 rounded-xl p-5 shadow-2xl">
            <div className="flex items-center gap-4">
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-red-950/50 border border-red-700/50">
                <i className="ri-map-pin-line text-red-500 text-xl" />
              </div>
              <div>
                <span className="font-['Exo_2'] font-bold text-white text-sm block">Sede: Firenze</span>
                <span className="font-['Inter'] text-gray-500 text-xs">Attivi in tutta Europa</span>
              </div>
            </div>
          </div>

          {/* Decorative line */}
          <div className="absolute -left-4 top-1/4 bottom-1/4 w-[2px] bg-gradient-to-b from-transparent via-red-600/60 to-transparent" />
        </div>

        {/* Right - Content */}
        <div>
          <div className="inline-flex items-center gap-2 px-4 py-1.5 border border-red-800/40 rounded-full mb-8 bg-red-950/10">
            <span className="font-['Exo_2'] text-xs text-red-400 tracking-[0.3em] uppercase">Chi Siamo</span>
          </div>

          <h2 className="font-['Exo_2'] font-black text-white text-4xl md:text-5xl tracking-tight mb-6 leading-tight">
            PARTNER <span className="text-red-500">SOLIDO</span><br />
            PER IL TUO<br />
            <span className="text-gray-400">SUCCESSO</span>
          </h2>

          <p className="font-['Inter'] text-gray-400 text-base leading-relaxed mb-6">
            <strong className="text-white">ELLE NOLO EQUIPMENT Srl</strong> è una realtà giovane e dinamica con sede a Firenze,
            specializzata nel noleggio di attrezzature per il motorsport, eventi fieristici, stand, catering e ricambistica auto.
          </p>

          <p className="font-['Inter'] text-gray-500 text-sm leading-relaxed mb-10">
            Fondata con l&apos;intento di rispondere alle esigenze di un mercato in continua evoluzione, la nostra società si è
            rapidamente affermata come un partner affidabile e concreto per le aziende e i professionisti del settore.
            Siamo attivi su tutto il territorio europeo, offrendo soluzioni su misura per le principali manifestazioni ed eventi.
          </p>

          {/* Features */}
          <div className="flex flex-col gap-4">
            {features.map((f) => (
              <div
                key={f.title}
                className={`flex items-start gap-4 p-4 rounded-xl border ${f.border} ${f.bg} transition-all duration-300 hover:border-opacity-60`}
              >
                <div className={`w-10 h-10 flex items-center justify-center rounded-lg bg-black/30 flex-shrink-0`}>
                  <i className={`${f.icon} ${f.color} text-xl`} />
                </div>
                <div>
                  <span className="font-['Exo_2'] font-bold text-white text-sm block mb-1">{f.title}</span>
                  <span className="font-['Inter'] text-gray-500 text-xs leading-relaxed">{f.desc}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default AboutSection;
